import type { DeveloperTranslation } from './types';

/** Hindi. Pending review by native speakers. */
export const developerHi: DeveloperTranslation = {
  nav: 'डेवलपर',
  title: 'डेवलपर',
  description:
    'अपने सिस्टम जोड़ें: सर्वर इंटीग्रेशन के लिए API कुंजियाँ, उन्हें होने वाली घटनाएँ बताने वाले वेबहुक, और वे होस्ट जिन्हें Hamnivo कॉल कर सकता है।',
  apiReference: 'API संदर्भ',
  newTab: '(नए टैब में खुलता है)',
  tabs: {
    keys: 'API कुंजियाँ',
    webhooks: 'वेबहुक',
    events: 'इवेंट लॉग',
    hosts: 'अनुमत होस्ट',
  },
  reveal: {
    description: 'इसे सुरक्षित जगह रखें; यह दोबारा नहीं दिखाया जाएगा।',
    copy: 'कॉपी करें',
    copied: 'कॉपी हो गया',
    copyFailed: 'कॉपी नहीं हो सका। टेक्स्ट चुना हुआ है; इसे ख़ुद कॉपी करें।',
    once: 'Hamnivo केवल इसकी एक फ़िंगरप्रिंट रखता है। खो जाने पर नया पाने के लिए इसे रोटेट करें।',
    done: 'हो गया',
  },
  permissions: {
    analytics: {
      read: {
        name: 'रिपोर्ट पढ़ें',
        hint: 'सेवा-गुणवत्ता के कुल आँकड़े और CSV एक्सपोर्ट। संदेशों की सामग्री नहीं।',
      },
    },
    billing: {
      read: { name: 'बिलिंग पढ़ें', hint: 'प्लान, उसकी सीमाओं के मुक़ाबले उपयोग, और इनवॉइस।' },
    },
    webhooks: {
      read: {
        name: 'वेबहुक पढ़ें',
        hint: 'एंडपॉइंट, डिलीवरी लॉग और इवेंट प्रकार। साइनिंग सीक्रेट नहीं।',
      },
    },
    mcp: {
      read: {
        name: 'MCP से पढ़ना',
        hint: 'Claude जैसे एआई सहायक को बातचीत खोजने, ग्राहकों ने जो देखा वह पढ़ने, और जानकारी, ग्राहक की स्मृति और खुले हैंड-ऑफ़ देखने देता है। सिर्फ़ पढ़ने के लिए।',
      },
    },
  },
  keys: {
    title: 'API कुंजियाँ',
    description:
      'कुंजी से कोई सर्वर अपने सर्विस अकाउंट के रूप में Hamnivo API को कॉल कर सकता है — केवल उन अनुमतियों के साथ जो आप दें, और कभी आपकी अनुमतियों से ज़्यादा नहीं।',
    readOnly: 'आप कुंजियाँ देख सकते हैं, पर उन्हें बनाना या बदलना केवल API कुंजियाँ संभालने वाले लोग कर सकते हैं।',
    loading: 'API कुंजियाँ लोड हो रही हैं',
    empty: 'अभी कोई API कुंजी नहीं है।',
    neverUsed: 'कभी उपयोग नहीं हुई',
    scopeTenant: 'पूरा वर्कस्पेस',
    scopeBrand: 'ब्रांड: {{brand}}',
    scopeType: {
      workspace: 'एक वर्कस्पेस',
      brand: 'एक ब्रांड',
      team: 'एक टीम',
      inbox: 'एक इनबॉक्स',
    },
    status: {
      active: 'सक्रिय',
      rotating: 'बदली जा रही है',
      expired: 'समाप्त',
      revoked: 'रद्द',
    },
    columns: {
      name: 'नाम',
      key: 'कुंजी',
      access: 'पहुँच',
      status: 'स्थिति',
      lastUsed: 'आख़िरी उपयोग',
      expires: 'समाप्ति',
      actions: 'कार्रवाइयाँ',
    },
    create: {
      open: 'कुंजी बनाएँ',
      title: 'API कुंजी बनाएँ',
      description: 'कुंजी को केवल वही दें जिसकी इंटीग्रेशन को ज़रूरत है। हर कुंजी की समाप्ति होती है।',
      name: 'नाम',
      nameHint: 'ऐसा नाम जो बताए कि यह कहाँ उपयोग होती है, जैसे “ऑर्डर सिस्टम”।',
      permissions: 'अनुमतियाँ',
      notYours: 'यह अनुमति आपके पास ख़ुद नहीं है, इसलिए आप इसे नहीं दे सकते।',
      scope: 'कहाँ लागू होती है',
      scopeHint: 'बिलिंग और वेबहुक हमेशा पूरे वर्कस्पेस पर लागू होते हैं।',
      expiry: 'समाप्ति',
      expiryHint: 'समाप्ति से पहले कुंजी रोटेट करें; पुरानी कुंजी कुछ समय तक चलती रह सकती है।',
      days: '{{count}} दिन',
      submit: 'कुंजी बनाएँ',
    },
    rotate: {
      button: 'रोटेट करें',
      label: '{{name}} रोटेट करें',
      title: '“{{name}}” रोटेट करें?',
      description:
        'आपको उन्हीं अनुमतियों वाली नई कुंजी मिलेगी। अपना इंटीग्रेशन अपडेट करें, फिर पुरानी कुंजी को समाप्त होने दें।',
      overlap: 'पुरानी कुंजी चलती रहेगी',
      overlaps: {
        '0': 'बिल्कुल नहीं: अभी बंद',
        '60': 'एक घंटा',
        '1440': 'एक दिन',
        '10080': 'एक सप्ताह',
      },
      confirm: 'कुंजी रोटेट करें',
      unchanged: 'कुंजी रोटेट नहीं हुई; मौजूदा कुंजी अब भी चलती है।',
    },
    revoke: {
      button: 'रद्द करें',
      label: '{{name}} रद्द करें',
      title: '“{{name}}” रद्द करें?',
      description: 'इस कुंजी वाले अनुरोध तुरंत काम करना बंद कर देंगे। इसे पूर्ववत नहीं किया जा सकता।',
      confirm: 'कुंजी रद्द करें',
      done: '{{name}} रद्द कर दी गई।',
    },
    reveal: {
      title: 'API कुंजी बन गई',
      label: '{{name}} के लिए API कुंजी',
    },
  },
  webhooks: {
    title: 'वेबहुक',
    description:
      'कुछ होने पर Hamnivo आपके एंडपॉइंट पर साइन किए गए HTTPS अनुरोध भेजता है। आंतरिक नोट कभी नहीं भेजे जाते।',
    add: 'एंडपॉइंट जोड़ें',
    loading: 'वेबहुक एंडपॉइंट लोड हो रहे हैं',
    empty: 'अभी कोई एंडपॉइंट नहीं है। इवेंट पाने के लिए एक जोड़ें।',
    noDeliveries: 'अभी कुछ नहीं भेजा गया',
    eventCount: 'इवेंट: {{count}}',
    open: 'खोलें',
    openLabel: '{{url}} खोलें',
    created: 'एंडपॉइंट जोड़ा गया',
    secret: 'साइनिंग सीक्रेट',
    secretLabel: 'साइनिंग सीक्रेट',
    verifiedAt: 'परीक्षण का उत्तर मिला {{time}}',
    notVerified: 'अभी परीक्षण नहीं हुआ',
    previousValid: 'पिछला सीक्रेट भी {{time}} तक साइन करता है।',
    blocked:
      'इस एंडपॉइंट का होस्ट अनुमत होस्ट की सूची में नहीं है, इसलिए इसे डिलीवरी अस्वीकार की जाती है। होस्ट को “अनुमत होस्ट” में जोड़ें।',
    failingNote:
      'लगातार असफल प्रयास: {{count}}। डिलीवरी लगभग तीन दिन तक दोबारा कोशिश की जाती है; लगातार असफल होने वाला एंडपॉइंट बंद कर दिया जाता है।',
    edit: 'संपादित करें',
    status: {
      active: 'सक्रिय',
      failing: 'ध्यान देने की ज़रूरत',
    },
    disabled: {
      manual: 'बंद',
      failing: 'बंद: लगातार असफल',
      gone: 'बंद: एंडपॉइंट मौजूद नहीं',
    },
    columns: {
      url: 'पता',
      status: 'स्थिति',
      events: 'इवेंट',
      latest: 'आख़िरी डिलीवरी',
      open: 'विवरण',
    },
    categories: {
      conversations: 'बातचीत',
      messages: 'संदेश',
      handoffs: 'व्यक्ति को सौंपना',
      orders: 'ऑर्डर',
      payments: 'भुगतान',
      refunds: 'रिफ़ंड',
      memory: 'ग्राहक मेमोरी',
      usage: 'उपयोग',
      testing: 'परीक्षण',
    },
    events: {
      conversation_created: 'एक बातचीत शुरू हुई।',
      conversation_updated: 'कौन जवाब देता है, या ग्राहक को दिखने वाली स्थिति बदली।',
      conversation_resolved: 'एक बातचीत हल हुई।',
      conversation_reopened: 'एक बातचीत फिर से खुली।',
      message_created: 'ग्राहक को दिखने वाला संदेश भेजा गया।',
      handoff_requested: 'बातचीत किसी व्यक्ति की प्रतीक्षा में है।',
      handoff_accepted: 'किसी व्यक्ति ने बातचीत सँभाली।',
      handoff_returned: 'बातचीत AI सहायक को लौट गई।',
      order_created: 'एक ऑर्डर दिया गया।',
      order_updated: 'ऑर्डर की स्थिति बदली।',
      payment_updated: 'भुगतान की स्थिति बदली।',
      refund_created: 'रिफ़ंड का अनुरोध हुआ।',
      refund_updated: 'रिफ़ंड की स्थिति बदली।',
      memory_deleted: 'ग्राहक मेमोरी हटाई गई (सामग्री के बिना रसीद)।',
      usage_threshold_reached: 'उपयोग अलर्ट सीमा तक पहुँचा।',
      webhook_test: 'Studio या API से भेजा गया परीक्षण इवेंट।',
    },
    form: {
      title: 'एंडपॉइंट जोड़ें',
      editTitle: 'एंडपॉइंट संपादित करें',
      description:
        'सार्वजनिक इंटरनेट पर HTTPS पता उपयोग करें। जोड़ने के बाद साइनिंग सीक्रेट एक बार दिखाया जाता है।',
      url: 'एंडपॉइंट का पता',
      urlHint: 'उदाहरण: https://hooks.example.com/hamnivo',
      note: 'विवरण',
      events: 'भेजे जाने वाले इवेंट',
      submit: 'एंडपॉइंट जोड़ें',
      save: 'बदलाव सहेजें',
      saved: 'एंडपॉइंट सहेजा गया।',
    },
    test: {
      button: 'परीक्षण इवेंट भेजें',
      verified: 'आपके एंडपॉइंट ने साइन किया गया परीक्षण इवेंट स्वीकार किया।',
      verifiedBadge: 'सत्यापित',
      failed: 'परीक्षण इवेंट स्वीकार नहीं हुआ। नीचे उत्तर देखें।',
    },
    rotate: {
      button: 'सीक्रेट रोटेट करें',
      title: 'साइनिंग सीक्रेट रोटेट करें?',
      description:
        'ओवरलैप के दौरान हर अनुरोध में दो हस्ताक्षर होते हैं, हर सीक्रेट के लिए एक, ताकि आपका रिसीवर बिना कोई इवेंट खोए बदल सके।',
      overlap: 'पुराने सीक्रेट से साइन करते रहें',
      overlaps: {
        '0': 'बिल्कुल नहीं: अभी बंद',
        '1': 'एक घंटा',
        '24': 'एक दिन',
        '72': 'तीन दिन',
      },
      confirm: 'सीक्रेट रोटेट करें',
      unchanged: 'सीक्रेट रोटेट नहीं हुआ; मौजूदा सीक्रेट अब भी साइन करता है।',
      revealTitle: 'नया साइनिंग सीक्रेट',
    },
    turnOff: {
      button: 'बंद करें',
      title: 'यह एंडपॉइंट बंद करें?',
      description:
        'इसे आगे कुछ नहीं भेजा जाएगा, और दोबारा कोशिश की प्रतीक्षा वाली डिलीवरी रद्द होंगी। चालू करने के बाद आप उन्हें दोबारा भेज सकते हैं।',
      confirm: 'बंद करें',
      done: 'एंडपॉइंट बंद किया गया।',
    },
    turnOn: {
      button: 'चालू करें',
      title: 'यह एंडपॉइंट चालू करें?',
      description: 'नए इवेंट फिर से भेजे जाएँगे, और असफलताओं की गिनती शून्य से शुरू होगी।',
      confirm: 'चालू करें',
      done: 'एंडपॉइंट चालू किया गया।',
    },
    replayFailed: {
      button: 'असफल दोबारा भेजें',
      title: 'असफल डिलीवरी दोबारा भेजें?',
      description:
        'इस अवधि में इस एंडपॉइंट की हर असफल या रद्द डिलीवरी उसी मूल इवेंट ID के साथ फिर से भेजी जाएगी।',
      since: 'असफल हुई',
      windows: {
        '1': 'पिछले 24 घंटे',
        '3': 'पिछले 3 दिन',
        '7': 'पिछले 7 दिन',
      },
      confirm: 'डिलीवरी दोबारा भेजें',
      done: 'दोबारा भेजने के लिए कतार में: {{count}}। दोबारा भेजने के लिए बहुत पुरानी: {{expired}}।',
    },
    delete: {
      button: 'हटाएँ',
      title: 'यह एंडपॉइंट हटाएँ?',
      description:
        'इसका डिलीवरी इतिहास भी हटेगा और इसके साइनिंग सीक्रेट काम करना बंद कर देंगे। इसे पूर्ववत नहीं किया जा सकता।',
      confirm: 'एंडपॉइंट हटाएँ',
      done: 'एंडपॉइंट हटाया गया।',
    },
  },
  deliveries: {
    title: 'डिलीवरी इतिहास',
    loading: 'डिलीवरी लोड हो रही हैं',
    loadingDetail: 'डिलीवरी लोड हो रही है',
    empty: 'इस एंडपॉइंट पर अभी कुछ नहीं भेजा गया।',
    detailTitle: 'डिलीवरी विवरण',
    event: 'इवेंट',
    eventId: 'इवेंट ID',
    statusLabel: 'स्थिति',
    attempts: 'प्रयास',
    attemptsOf: 'प्रयास: {{max}} में से {{count}}',
    attemptNumber: 'प्रयास {{number}}',
    nextAttempt: 'अगला प्रयास',
    replayed: 'दोबारा भेजा गया',
    answer: 'उत्तर:',
    preview: 'पेलोड पूर्वावलोकन',
    previewNote: 'लोगों ने क्या लिखा और वे कौन हैं, यह यहाँ छिपा है; आपके एंडपॉइंट को पूरा इवेंट मिला।',
    expired: 'इवेंट संग्रहण अवधि से पुराना है, इसलिए उसकी सामग्री अब नहीं रखी जाती।',
    status: {
      pending: 'दोबारा कोशिश हो रही है',
      succeeded: 'डिलीवर हुआ',
      failed: 'असफल',
      cancelled: 'रद्द',
    },
    outcomes: {
      succeeded: 'स्वीकृत',
      http_error: 'त्रुटि वाला उत्तर',
      redirect: 'रीडायरेक्ट (फ़ॉलो नहीं किया)',
      timeout: 'समय समाप्त',
      network: 'कनेक्शन असफल',
      tls: 'प्रमाणपत्र की समस्या',
      blocked: 'अस्वीकृत',
      unresolvable: 'होस्ट नहीं मिला',
    },
    replay: {
      button: 'यह डिलीवरी दोबारा भेजें',
      title: 'यह डिलीवरी दोबारा भेजें?',
      description: '{{event}} इवेंट फिर से भेजें:',
      dedupe:
        'रिसीवर को इवेंट ID से दोहराव हटाना चाहिए: दोबारा भेजी गई डिलीवरी में मूल वाला ही webhook-id होता है।',
      confirm: 'डिलीवरी दोबारा भेजें',
      queued: 'दोबारा भेजना कतार में है।',
      turnOnFirst: 'डिलीवरी दोबारा भेजने के लिए एंडपॉइंट चालू करें।',
    },
  },
  events: {
    title: 'इवेंट लॉग',
    description: 'आपके एंडपॉइंट पर भेजे गए इवेंट, नए पहले, उनकी डिलीवरी के हाल के साथ।',
    filter: 'इवेंट प्रकार',
    allTypes: 'सभी इवेंट प्रकार',
    loading: 'इवेंट लोड हो रहे हैं',
    empty: 'अभी कोई इवेंट नहीं। कम से कम एक एंडपॉइंट चालू रहने पर इवेंट दर्ज होते हैं।',
    emptyFiltered: 'इस प्रकार के इवेंट अभी नहीं हैं।',
    more: 'पुराने इवेंट दिखाएँ',
    counts: 'डिलीवर {{succeeded}} · असफल {{failed}} · दोबारा कोशिश {{pending}}',
    columns: {
      type: 'इवेंट',
      id: 'इवेंट ID',
      occurred: 'कब हुआ',
      deliveries: 'डिलीवरी',
    },
  },
  hosts: {
    title: 'अनुमत होस्ट',
    description:
      'इस वर्कस्पेस के लिए Hamnivo किन होस्ट को कॉल कर सकता है, जैसे आपके वेबहुक एंडपॉइंट, इसे सीमित करें। कोई होस्ट सूचीबद्ध न होने पर कोई भी सार्वजनिक होस्ट अनुमत है।',
    always: 'निजी नेटवर्क, यह सर्वर और लोकल पते हमेशा अस्वीकार होते हैं, चाहे यहाँ कुछ भी लिखा हो।',
    loading: 'अनुमत होस्ट लोड हो रहे हैं',
    modeAny: 'कोई भी सार्वजनिक होस्ट अनुमत है।',
    modeList: 'केवल नीचे दिए होस्ट अनुमत हैं।',
    empty: 'कोई होस्ट सूचीबद्ध नहीं।',
    pattern: 'होस्ट',
    patternHint: 'hooks.example.com जैसा होस्ट, या उसके सबडोमेन के लिए *.example.com।',
    note: 'नोट',
    remove: '{{host}} हटाएँ',
    removeShort: 'हटाएँ',
    add: 'होस्ट जोड़ें',
    save: 'अनुमत होस्ट सहेजें',
    savedList: 'अनुमत होस्ट सहेजे गए: {{count}}।',
    savedAny: 'सहेजा गया। कोई भी सार्वजनिक होस्ट अनुमत है।',
    readOnly: 'नेटवर्क सूची केवल उसे संभालने वाले लोग बदल सकते हैं।',
    blocked: 'ये एंडपॉइंट सूची में नहीं हैं, इसलिए इन्हें डिलीवरी अस्वीकार की जाती है:',
  },
};
